import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check, Download, Mail, X } from "lucide-react";
import { downloadTicketPdf, makeQrDataUrl, qrPayload } from "../utils/pdfGenerator";
import { TicketPreview } from "./TicketPreview";

export const ConfirmationModal = ({ booking, onClose }) => {
  const [qr, setQr] = useState("");
  useEffect(() => {
    makeQrDataUrl(qrPayload(booking)).then(setQr).catch(() => {});
  }, [booking]);

  return (
    <div className="modal-backdrop">
      <motion.div
        className="confirmation wide"
        role="dialog"
        aria-modal="true"
        data-testid="booking-confirmation"
        initial={{ opacity: 0, y: 28, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        <button className="modal-close" onClick={onClose} data-testid="close-confirmation-button"><X size={18} /></button>
        <div className="confirmation-icon"><Check size={29} /></div>
        <p className="eyebrow centered">Step 03 — All set</p>
        <h2>Your darshan is reserved.</h2>
        <p className="confirm-copy">A confirmation for <strong>{booking.name}</strong> has been created. Carry the original photo ID used during booking when you report.</p>
        <div className="ref-strip"><span>Group Booking ID</span><strong data-testid="booking-reference">{booking.booking_id}</strong></div>
        {booking.email_sent ? (
          <p className="email-status ok" data-testid="email-status"><Mail size={14} /> E-ticket emailed to {booking.email}</p>
        ) : (
          <p className="email-status" data-testid="email-status"><Mail size={14} /> Email delivery is unavailable right now — download your e-ticket below</p>
        )}
        <TicketPreview booking={booking} qr={qr} />
        <button className="secondary-button" onClick={() => downloadTicketPdf(booking)} data-testid="download-ticket-button"><Download size={16} /> Download PDF e-ticket</button>
      </motion.div>
    </div>
  );
};
